import {
  getMenuOrderingSettings as publicGetMenuOrderingSettings,
  upsertMenuOrderingSettingsByMenuId as publicUpsertMenuOrderingSettingsByMenuId,
  updateMenuOrderingSettings as publicUpdateMenuOrderingSettings,
  queryMenuOrderingSettings as publicQueryMenuOrderingSettings,
  typedQueryMenuOrderingSettings as publicTypedQueryMenuOrderingSettings,
  bulkUpdateMenuOrderingSettings as publicBulkUpdateMenuOrderingSettings,
  listMenusAvailabilityStatus as publicListMenusAvailabilityStatus,
  updateExtendedFields as publicUpdateExtendedFields,
  bulkUpdateMenuOrderingSettingsTags as publicBulkUpdateMenuOrderingSettingsTags,
  bulkUpdateMenuOrderingSettingsTagsByFilter as publicBulkUpdateMenuOrderingSettingsTagsByFilter,
} from './restaurants-menu-settings-v1-menu-ordering-settings-menu-ordering-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  MenuOrderingSettingsQuery,
  MenuOrderingSettingsQueryBuilder,
  typedQueryMenuOrderingSettings as universalTypedQueryMenuOrderingSettings,
} from './restaurants-menu-settings-v1-menu-ordering-settings-menu-ordering-settings.universal.js';
import { onMenuOrderingSettingsCreated as publicOnMenuOrderingSettingsCreated } from './restaurants-menu-settings-v1-menu-ordering-settings-menu-ordering-settings.public.js';
import { onMenuOrderingSettingsDeleted as publicOnMenuOrderingSettingsDeleted } from './restaurants-menu-settings-v1-menu-ordering-settings-menu-ordering-settings.public.js';
import { onMenuOrderingSettingsUpdated as publicOnMenuOrderingSettingsUpdated } from './restaurants-menu-settings-v1-menu-ordering-settings-menu-ordering-settings.public.js';

function customQueryMenuOrderingSettings(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryMenuOrderingSettings(httpClient)(),
    typedQueryFunction: (query: MenuOrderingSettingsQuery) =>
      publicTypedQueryMenuOrderingSettings(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): MenuOrderingSettingsQueryBuilder;
  function overloadedQuery(
    query: MenuOrderingSettingsQuery
  ): ReturnType<typeof universalTypedQueryMenuOrderingSettings>;
  function overloadedQuery(query?: MenuOrderingSettingsQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const getMenuOrderingSettings: MaybeContext<
  BuildRESTFunction<typeof publicGetMenuOrderingSettings> &
    typeof publicGetMenuOrderingSettings
> = /*#__PURE__*/ createRESTModule(publicGetMenuOrderingSettings);
export const upsertMenuOrderingSettingsByMenuId: MaybeContext<
  BuildRESTFunction<typeof publicUpsertMenuOrderingSettingsByMenuId> &
    typeof publicUpsertMenuOrderingSettingsByMenuId
> = /*#__PURE__*/ createRESTModule(publicUpsertMenuOrderingSettingsByMenuId);
export const updateMenuOrderingSettings: MaybeContext<
  BuildRESTFunction<typeof publicUpdateMenuOrderingSettings> &
    typeof publicUpdateMenuOrderingSettings
> = /*#__PURE__*/ createRESTModule(publicUpdateMenuOrderingSettings);
export const bulkUpdateMenuOrderingSettings: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateMenuOrderingSettings> &
    typeof publicBulkUpdateMenuOrderingSettings
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateMenuOrderingSettings);
export const listMenusAvailabilityStatus: MaybeContext<
  BuildRESTFunction<typeof publicListMenusAvailabilityStatus> &
    typeof publicListMenusAvailabilityStatus
> = /*#__PURE__*/ createRESTModule(publicListMenusAvailabilityStatus);
export const updateExtendedFields: MaybeContext<
  BuildRESTFunction<typeof publicUpdateExtendedFields> &
    typeof publicUpdateExtendedFields
> = /*#__PURE__*/ createRESTModule(publicUpdateExtendedFields);
export const bulkUpdateMenuOrderingSettingsTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateMenuOrderingSettingsTags> &
    typeof publicBulkUpdateMenuOrderingSettingsTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateMenuOrderingSettingsTags);
export const bulkUpdateMenuOrderingSettingsTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateMenuOrderingSettingsTagsByFilter> &
    typeof publicBulkUpdateMenuOrderingSettingsTagsByFilter
> = /*#__PURE__*/ createRESTModule(
  publicBulkUpdateMenuOrderingSettingsTagsByFilter
);
export const queryMenuOrderingSettings: MaybeContext<
  BuildRESTFunction<typeof customQueryMenuOrderingSettings> &
    typeof customQueryMenuOrderingSettings
> = /*#__PURE__*/ createRESTModule(customQueryMenuOrderingSettings);
/** */
export const onMenuOrderingSettingsCreated: BuildEventDefinition<
  typeof publicOnMenuOrderingSettingsCreated
> &
  typeof publicOnMenuOrderingSettingsCreated = createEventModule(
  publicOnMenuOrderingSettingsCreated
);
/** */
export const onMenuOrderingSettingsDeleted: BuildEventDefinition<
  typeof publicOnMenuOrderingSettingsDeleted
> &
  typeof publicOnMenuOrderingSettingsDeleted = createEventModule(
  publicOnMenuOrderingSettingsDeleted
);
/** */
export const onMenuOrderingSettingsUpdated: BuildEventDefinition<
  typeof publicOnMenuOrderingSettingsUpdated
> &
  typeof publicOnMenuOrderingSettingsUpdated = createEventModule(
  publicOnMenuOrderingSettingsUpdated
);

export {
  AvailabilityType,
  EntitiesDayOfWeek,
  SortOrder,
  AvailabilityStatus,
  PlacementType,
  DayOfWeek,
  ResolutionMethod,
  WebhookIdentityType,
} from './restaurants-menu-settings-v1-menu-ordering-settings-menu-ordering-settings.universal.js';
export {
  MenuOrderingSettings,
  Availability,
  AvailabilityAvailabilityTypeOptionsOneOf,
  WeeklyScheduleOptions,
  DayOfWeekAvailability,
  TimeOfDayRange,
  TimeOfDay,
  TimestampRangesOptions,
  AvailableRange,
  ExtendedFields,
  Tags,
  TagList,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  CreateMenuOrderingSettingsRequest,
  CreateMenuOrderingSettingsResponse,
  GetMenuOrderingSettingsRequest,
  GetMenuOrderingSettingsResponse,
  UpsertMenuOrderingSettingsByMenuIdRequest,
  UpsertMenuOrderingSettingsByMenuIdResponse,
  UpdateMenuOrderingSettingsRequest,
  UpdateMenuOrderingSettingsResponse,
  DeleteMenuOrderingSettingsRequest,
  DeleteMenuOrderingSettingsResponse,
  QueryMenuOrderingSettingsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryMenuOrderingSettingsResponse,
  CursorPagingMetadata,
  Cursors,
  BulkUpdateMenuOrderingSettingsRequest,
  MaskedMenuOrderingSettings,
  BulkUpdateMenuOrderingSettingsResponse,
  ItemMetadata,
  ApplicationError,
  BulkMenuOrderingSettingsResult,
  BulkActionMetadata,
  ListMenusAvailabilityStatusRequest,
  TimeSlot,
  ListMenusAvailabilityStatusResponse,
  MenuAvailabilityStatus,
  UpdateExtendedFieldsRequest,
  UpdateExtendedFieldsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  GetRestaurantsAppClonesStatusRequest,
  GetRestaurantsAppClonesStatusResponse,
  RestaurantsAppCloneStatus,
  SitePropertiesNotification,
  SitePropertiesEvent,
  Properties,
  Categories,
  Locale,
  Address,
  AddressHint,
  GeoCoordinates,
  BusinessSchedule,
  TimePeriod,
  SpecialHourPeriod,
  Multilingual,
  SupportedLanguage,
  ConsentPolicy,
  Translation,
  ChangeContext,
  ChangeContextPayloadOneOf,
  PropertiesChange,
  SiteCreated,
  SiteCloned,
  OperationsDataCloningCompleted,
  MenusDataCloningCompleted,
  BulkUpdateMenuOrderingSettingsTagsRequest,
  BulkUpdateMenuOrderingSettingsTagsResponse,
  CommonItemMetadata,
  BulkUpdateMenuOrderingSettingsTagsResult,
  CommonBulkActionMetadata,
  BulkUpdateMenuOrderingSettingsTagsByFilterRequest,
  BulkUpdateMenuOrderingSettingsTagsByFilterResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  MenuOrderingSettingsCreatedEnvelope,
  MenuOrderingSettingsDeletedEnvelope,
  MenuOrderingSettingsUpdatedEnvelope,
  UpsertMenuOrderingSettingsByMenuIdMenuOrderingSettings,
  UpdateMenuOrderingSettings,
  MenuOrderingSettingsQueryResult,
  MenuOrderingSettingsQueryBuilder,
  MenuOrderingSettingsQuerySpec,
  BulkUpdateMenuOrderingSettingsOptions,
  ListMenusAvailabilityStatusOptions,
  UpdateExtendedFieldsOptions,
  BulkUpdateMenuOrderingSettingsTagsOptions,
  BulkUpdateMenuOrderingSettingsTagsByFilterOptions,
} from './restaurants-menu-settings-v1-menu-ordering-settings-menu-ordering-settings.universal.js';
export { utils } from './restaurants-menu-settings-v1-menu-ordering-settings-menu-ordering-settings.universal.js';
export {
  AvailabilityTypeWithLiterals,
  EntitiesDayOfWeekWithLiterals,
  SortOrderWithLiterals,
  AvailabilityStatusWithLiterals,
  PlacementTypeWithLiterals,
  DayOfWeekWithLiterals,
  ResolutionMethodWithLiterals,
  WebhookIdentityTypeWithLiterals,
  BulkUpdateMenuOrderingSettingsTagsApplicationErrors,
  BulkUpdateMenuOrderingSettingsTagsByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  MenuOrderingSettingsQuery,
} from './restaurants-menu-settings-v1-menu-ordering-settings-menu-ordering-settings.universal.js';
